module.exports = __webpack_public_path__ + "img/8.60337bc8.png";